<template>
  <section class="content">
    <ul class="product-list">
      <li class="product-list__item product-list__item--micro">
        <div class="product-list__item-info">
          <h2 class="product-list__item-title">Микрокредит</h2>
          <p class="product-list__short-description">на любые цели,<br> погашение ежемесячно</p>
          <ul class="product-list__conditions">
            <li class="product-list__condition-item"><span class="icon icon--lock-v"></span>Без залога</li>
            <li class="product-list__condition-item"><span class="icon icon--tenge-v"></span>Сумма от 100 000
              до 1 000 000 тенге
            </li>
            <li class="product-list__condition-item"><span class="icon icon--calendar-12"></span>Срок от 1 месяца до 12 месяцев
            </li>
          </ul>
          <div class="product-list__button-wrap">
            <router-link tag="button" :to="{name: 'Micro', params: {lang: this.$route.params.lang} }"
                         class="product-list__button button button--violet">{{microLabel}}</router-link>
          </div>
        </div>
      </li>
      <li class="product-list__item product-list__item--business">
        <div class="product-list__item-info">
          <h2 class="product-list__item-title">Бизнес кредит</h2>
          <p class="product-list__short-description">для предпринимателей на развитие бизнеса</p>
          <ul class="product-list__conditions">
            <li class="product-list__condition-item"><span class="icon icon--lock-y"></span>Без залога</li>
            <li class="product-list__condition-item"><span class="icon icon--tenge-y"></span>Микрокредит до 1 000 000 тенге
            </li>
            <li class="product-list__condition-item"><span class="icon icon--calendar-36"></span>Срок 12 месяцев
            </li>
          </ul>
          <div class="product-list__button-wrap">
            <router-link tag="button" :to="{name: 'Business', params: {lang: this.$route.params.lang} }"
                         class="product-list__button button button--yellow">{{businessLabel}}</router-link>
          </div>
        </div>
      </li>
    </ul>
    <why-micro></why-micro>
    <div class="how-it-work">
      <h2 class="how-it-work__title">Как это работает?</h2>
      <p class="how-it-work__description">Деньги на банковский счёт в несколько действий</p>
      <ul v-if="!isMobile" class="how-it-work__steps-list">
        <li class="how-it-work__step" v-for="item in howItWork" :key="item.id">
          <img v-bind:src="item.image" v-bind:alt="item.image_alt" class="how-it-work__step-icon">
          <p class="how-it-work__step-description">{{item.text}}</p>
        </li>
      </ul>
      <carousel :per-page="1" :navigationEnabled="true" :paginationActiveColor="'#93278F'" :paginationColor="'#FFB700'" v-else>
        <slide v-for="item in howItWork" :key="item.id">
          <div class="how-it-work__slide">
            <img v-bind:src="item.image" v-bind:alt="item.image_alt" class="how-it-work__slide-image">
            <p class="how-it-work__slide-description">{{item.text}}</p>
          </div>
        </slide>
      </carousel>
    </div>
    <call-center></call-center>
    <div class="about-products">
      <ul class="about-products__products-list">
        <li class="about-products__product-item about-products__product-item--micro">
          <p class="about-products__product-title">Микрокредит</p>
          <p class="about-products__product-description">на любые цели,<br>  погашение ежемесячно
          </p>
          <ul class="about-products__conditions">
            <li class="about-products__condition-item"><span class="icon icon--m icon--lock-v"></span>Без залога</li>
          </ul>
          <div class="about-products__button-wrap">
            <router-link class="about-products__link" tag="a" :to="{name: 'Micro', params: {lang: this.$route.params.lang} }">
              Подробнее
            </router-link>
          </div>
        </li>
        <li class="about-products__product-item about-products__product-item--business">
          <p class="about-products__product-title">Бизнес кредит</p>
          <p class="about-products__product-description">для предпринимателей<br> на развитие бизнеса</p>
          <ul class="about-products__conditions">
            <li class="about-products__condition-item"><span class="icon icon--m icon--lock-y"></span>Без залога</li>
          </ul>
          <div class="about-products__button-wrap">
            <router-link class="about-products__link" tag="a" :to="{name: 'Business', params: {lang: this.$route.params.lang} }">
              Подробнее
            </router-link>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
  import widthMixin from '@/modules/mixins/widthMixin'

  export default {
    mixins: [widthMixin],
    name: "Index",
    metaInfo: {
      title: 'Микро – получить микрокредит без залога онлайн в Казахстане',
      meta: [
        {name: 'description', content: 'Микро – это самый простой и удобный способ получить микрокредит в Казахстане. Для подачи заявки понадобятся только удостоверение личности, доступ к интернету и мобильный телефон'}
      ],
    },
    data(){
      return {
        howItWork: [
          {
            image: require('@/assets/img/index/how-it-work-1.svg'),
            image_alt: '1',
            text: 'Выберите сумму и срок микрокредита'
          },
          {
            image: require('@/assets/img/index/how-it-work-2.svg'),
            image_alt: '1',
            text: 'Получите подтверждение на мобильный телефон'
          },
          {
            image: require('@/assets/img/index/how-it-work-3.svg'),
            image_alt: '1',
            text: 'Подпишите договор'
          },
          {
            image: require('@/assets/img/index/how-it-work-4.svg'),
            image_alt: '1',
            text: 'Получите деньги'
          },
        ]
      }
    },
    computed: {
        microLabel: function () {
            return this.isDesktop ? 'Получить Микрокредит' : 'Получить микрокредит';
        },
        businessLabel: function () {
            return this.isDesktop ? 'Получить Бизнес Линию' : 'Получить микрокредит';
        }
    }
  };
</script>
<style lang="scss">
  @import "~@/assets/scss/variable";

  @import "~@/assets/scss/site/desktop/index/product-list";
  @import "~@/assets/scss/site/desktop/index/how-it-work";
  @import "~@/assets/scss/site/desktop/index/about-product";

  @import "~@/assets/scss/site/mobile/index/product-list";
  @import "~@/assets/scss/site/mobile/index/how-it-work";
  @import "~@/assets/scss/site/mobile/index/about-product";
</style>
